import toast from "react-hot-toast";

function asObject(value) {
  return value && typeof value === "object" && !Array.isArray(value) ? value : {};
}

export function normalizeApiError(error, fallbackMessage = "Er is iets misgegaan") {
  const response = error?.response;
  const data = asObject(response?.data);
  const status = Number(response?.status || 0);
  const details = asObject(data?.details);
  const requiredPermissions = Array.isArray(data?.requiredPermissions)
    ? data.requiredPermissions
        .map((value) => String(value || "").trim())
        .filter(Boolean)
    : [];

  const message =
    String(data?.message || "").trim() ||
    String(error?.message || "").trim() ||
    fallbackMessage;
  const code = String(data?.code || "").trim() || "UNKNOWN_ERROR";
  const errors = asObject(data?.errors) || asObject(details?.errors);

  return {
    status,
    message,
    code,
    errors,
    details,
    requiredPermissions,
    isValidationError: code === "VALIDATION_ERROR",
    raw: error,
  };
}

export function getApiErrorMessage(error, fallbackMessage) {
  return normalizeApiError(error, fallbackMessage).message;
}

export function getApiErrorCode(error) {
  return normalizeApiError(error).code;
}

export function getApiFieldErrors(error) {
  return normalizeApiError(error).errors;
}

export function hasApiErrorCode(error, expectedCode) {
  const actual = getApiErrorCode(error);
  if (Array.isArray(expectedCode)) {
    return expectedCode.includes(actual);
  }
  return actual === expectedCode;
}

export function showApiErrorToast(error, options = {}) {
  const { fallbackMessage = "Actie mislukt", codeMessages = {} } = options;
  const normalized = normalizeApiError(error, fallbackMessage);
  const message = codeMessages[normalized.code] || normalized.message || fallbackMessage;
  toast.error(message);
  return normalized;
}
